import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MoreIcon from "@rsuite/icons/legacy/More";
import NepaliDatePicker, { NepaliDate } from "@zener/nepali-datepicker-react";
import "@zener/nepali-datepicker-react/index.css";
import { format } from "date-fns";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  IconButton,
  Message,
  Schema,
  SelectPicker,
  Table,
  Tag,
  Tooltip,
  Whisper,
} from "rsuite";
import Swal from "sweetalert2";
import { eLoanStore } from "../../redux/store/eLoanApi";
import { toastError, toastSuccess, UserToken } from "../../utils/helper";
import PolicyDetails from "./policyDetails";

const { Column, HeaderCell, Cell } = Table;
const { StringType, MixedType } = Schema.Types;

const eLoanValidation = Schema.Model({
  policyNo: StringType().isRequired("This field is required."),
  mobileNo: StringType()
    .isRequired("This field is required.")
    .pattern(/^\d{10}$/, "Mobile number must be exactly 10 digits."),
  dob: MixedType()
    .isRequired("This field is required.")
    .addRule((value) => {
      const date = new Date(value);
      return date <= new Date();
    }, "Date of Birth cannot be in the future."),
});

export default function ELoan() {
  const {
    post_verifyPolicy,
    allPolicyList,
    post_getEloanDetails,
    getPolicyListByUserId,
    delete_deleteEloan,
  } = eLoanStore();
  const [eloanDetails, seteloanDetails] = useState([]);
  const [loading, setloading] = useState(true);
  const [editItem, seteditItem] = useState({});
  const [items, setItems] = React.useState([]);
  const [loader, setloader] = useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [policyDetails, setpolicyDetails] = useState({});
  const [bsValue, setBSValue] = useState("");

  const formRef = React.useRef();

  useEffect(() => {
    getInitalData();
  }, []);

  useEffect(() => {
    updateData();
  }, [allPolicyList]);

  const updateData = () => {
    if (allPolicyList.length > 0) {
      const data = allPolicyList.map((item) => ({
        label: item.PolicyNo,
        value: item.PolicyNo,
      }));
      setItems(data);
    }
  };

  const getInitalData = async () => {
    await UserToken();
    getPolicyListByUserId({});
    post_getEloanDetails({})
      .then((res) => {
        if (res.code === "100") {
          seteloanDetails(res.data);
          setloading(false);
          return;
        }
        seteloanDetails([]);
      })
      .finally(() => setloading(false));
  };

  const handleSubmit = async () => {
    if (!formRef.current.check()) {
      console.error("Form Error");
      return;
    }
    await verifyPolicy(editItem);
  };

  const verifyPolicy = async (formValue) => {
    setloader(true);
    Object.keys(editItem).length === 0 && seteditItem(formValue);
    await UserToken();
    post_verifyPolicy(formValue)
      .then((res) => {
        if (res.code === "100") {
          setOpenDrawer(true);
          setpolicyDetails(res.data);
          return;
        } else {
          Swal.fire({
            title: "Failed",
            text: res.message,
            icon: "question",
            confirmButtonColor: "#d33",
          });
          return;
        }
      })
      .catch((err) => {
        toastError(
          "Cannot connect to the API. Please reach out to the support team."
        );
      })
      .finally(() => setloader(false));
  };

  const deleteEloan = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await UserToken();
        delete_deleteEloan({
          rowId: id,
        })
          .then((res) => {
            if (res.code === "100") {
              getInitalData();
              toastSuccess(res.data);
              return;
            }
            toastError("Error in deleting data.");
          })
          .catch((err) => {
            toastError("Error in deleting data.");
          });
      }
    });
  };

  const getStatus = (status) => {
    if (status === "REGISTERED" || status === "PENDING") {
      return <Tag color="orange">Pending</Tag>;
    } else if (status === "FORWARDED") {
      return <Tag color="blue">Forwarded</Tag>;
    } else if (status === "APPROVED") {
      return <Tag color="green">Approved</Tag>;
    } else if (status === "ACTIVE") {
      return <Tag color="green">Disbursed</Tag>;
    } else {
      return <Tag color="red">{status}</Tag>;
    }
  };

  return (
    <React.Fragment>
      <div className="shadow bg-white rounded-lg p-4 mb-3">
        <h4 className="font-semibold text-lg mb-5">Apply for E-Loan</h4>

        <Form
          fluid
          ref={formRef}
          model={eLoanValidation}
          formValue={editItem}
          onChange={seteditItem}
          // onSubmit={handleSubmit}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">
            <Form.Group className="mb-0" controlId="policyNo">
              <Form.ControlLabel>Policy No.</Form.ControlLabel>
              <Form.Control
                accepter={SelectPicker}
                name="policyNo"
                data={items}
                searchable={false}
                block
              />
            </Form.Group>

            <Form.Group className="mb-0" controlId="mobileNo">
              <Form.ControlLabel>Mobile No.</Form.ControlLabel>
              <Form.Control name="mobileNo" />
            </Form.Group>

            <Form.Group className="mb-0" controlId="dobInBS">
              <Form.ControlLabel>Insured DOB (in BS)</Form.ControlLabel>
              <Form.Control
                accepter={NepaliDatePicker}
                value={bsValue}
                lang="en"
                type="BS"
                name="dobInBS"
                className="custom-zener-datepicker"
                max={new NepaliDate()}
                onChange={(e) => {
                  setBSValue(e);
                  seteditItem((prev) => ({
                    ...prev,
                    dob: e.toAD().toString(),
                    dobInBS: e.toString(),
                  }));

                  setTimeout(() => {
                    formRef.current.check();
                  }, 500);
                }}
                showclear={false}
              />
            </Form.Group>

            <Form.Group className="mb-0" controlId="dob">
              <Form.ControlLabel>Insured DOB (in AD)</Form.ControlLabel>
              <Form.Control
                accepter={NepaliDatePicker}
                value={editItem.dob}
                lang="en"
                type="AD"
                name="dob"
                className="custom-zener-datepicker"
                max={new Date()}
                onChange={(e) => {
                  setBSValue(e ? new NepaliDate(e) : null);
                  seteditItem((prev) => ({
                    ...prev,
                    dob: moment(e).format("YYYY-MM-DD").toString(),
                    dobInBS: new NepaliDate(e).toString(),
                  }));
                }}
                showclear={false}
              />
            </Form.Group>
          </div>

          <Message type="info" className="mb-5">
            <strong>Note:</strong> The system will automatically convert the BS
            to AD and AD to BS, displaying the corresponding date accordingly.
          </Message>

          <Button
            appearance="primary"
            className="btn-primary"
            onClick={handleSubmit}
            loading={loader}
          >
            Submit
          </Button>
        </Form>
      </div>

      <div className="shadow bg-white rounded-lg p-4">
        <div className="flex items-center justify-between mb-4">
          <h4 className="font-semibold text-lg mb-0">Previous E-Loan</h4>
        </div>
        <Table
          bordered
          cellBordered
          autoHeight
          wordWrap="keep-all"
          loading={loading}
          height={400}
          data={eloanDetails}
        >
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              Policy No
            </HeaderCell>
            <Cell dataKey="policyNo" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              Loan Amount
            </HeaderCell>
            <Cell dataKey="loanAmount" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              Loan Date
            </HeaderCell>
            <Cell style={{ padding: "13px 10px" }}>
              {(rowData) => {
                return (
                  <span>
                    {format(new Date(rowData.loanDate), "yyyy-MM-dd")}
                  </span>
                );
              }}
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              Bank Name
            </HeaderCell>
            <Cell dataKey="bankName" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              Bank Account No
            </HeaderCell>
            <Cell dataKey="bankAccountNo" />
          </Column>
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              Approved Date
            </HeaderCell>
            <Cell style={{ padding: "13px 10px" }}>
              {(rowData) => {
                return (
                  <span>
                    {rowData.approvedDate
                      ? format(new Date(rowData.approvedDate), "yyyy-MM-dd")
                      : ""}
                  </span>
                );
              }}
            </Cell>
          </Column>
          <Column flexGrow={1}>
            <HeaderCell className="font-semibold text-sm text-gray-700">
              status
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return <span>{getStatus(rowData.status)}</span>;
              }}
            </Cell>
          </Column>
          <Column width={100} fixed="right" align="center">
            <HeaderCell>
              <MoreIcon />
            </HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <span>
                    {rowData.isLoanApproved !== "1" ? (
                      <div className="flex justify-center gap-3">
                        {(rowData.status === "REGISTERED" ||
                          rowData.status === "PENDING") && (
                          <>
                            <Whisper
                              placement="top"
                              followCursor
                              speaker={<Tooltip>Edit</Tooltip>}
                            >
                              <IconButton
                                color="yellow"
                                size="sm"
                                appearance="primary"
                                icon={<FontAwesomeIcon icon={faPenToSquare} />}
                                onClick={() =>
                                  verifyPolicy({
                                    policyNo: rowData.policyNo,
                                    mobileNo: rowData.mobileNo,
                                    dob: rowData.dob,
                                  })
                                }
                              />
                            </Whisper>
                            <Whisper
                              placement="top"
                              followCursor
                              speaker={<Tooltip>Delete</Tooltip>}
                            >
                              <IconButton
                                color="red"
                                size="sm"
                                appearance="primary"
                                icon={<FontAwesomeIcon icon={faTrashCan} />}
                                onClick={() => deleteEloan(rowData.rowId)}
                              />
                            </Whisper>
                          </>
                        )}
                      </div>
                    ) : null}
                  </span>
                );
              }}
            </Cell>
          </Column>
        </Table>

        <PolicyDetails
          openDrawer={openDrawer}
          setOpenDrawer={setOpenDrawer}
          policyDetails={policyDetails}
          stepOneDetails={editItem}
        />
      </div>
    </React.Fragment>
  );
}
